"use client"

/**
 * CartInitializer Component
 *
 * Bridges server-side cart data to the client-side React Query cache.
 * Must be rendered on pages that have server-fetched cart data
 * to ensure the header cart icon shows the correct count on hydration.
 */

import { useEffect, useRef } from "react"
import { useCart } from "@/hooks/use-cart"
import { HttpTypes } from "@medusajs/types"

interface CartInitializerProps {
  cart: HttpTypes.StoreCart | null
}

export function CartInitializer({ cart }: CartInitializerProps) {
  const { setCart } = useCart()
  const hasInitialized = useRef(false)

  useEffect(() => {
    // Only initialize once per mount to avoid race conditions
    if (hasInitialized.current) return
    hasInitialized.current = true

    // Initialize React Query cache with server-side cart data
    if (cart) {
      setCart(cart)
    }
  }, [cart, setCart])

  // This component doesn't render anything
  return null
}

export default CartInitializer
